import {useContext} from 'react';
import {FiltersGroupContext} from '@contexts';

export const useFilterGroup = () => {
  return useContext(FiltersGroupContext);
};
